"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePlaceholder = exports.mapScopeToPermissions = exports.getDisplayName = exports["default"] = exports.deconstructPlaceholder = exports.comparePermission = exports.checkPermissions = exports.checkPermission = exports.authorizeFromRedux = exports.authorizeFromArray = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _excluded = ["grantedPermissions"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// This method returns the display name of the original wrapped component (used for debug output)
var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}; // This function compares if a permission matches a give permission regex


exports.getDisplayName = getDisplayName;

var comparePermission = function comparePermission(permission) {
  return function (permissionToCheck) {
    if (!permissionToCheck) return false;
    return permission.match(new RegExp("^".concat(permissionToCheck, "$"))) !== null;
  };
}; // This method checks if a permission is present in a given array of permissions


exports.comparePermission = comparePermission;

var checkPermission = function checkPermission(permissions) {
  return function (permissionToCheck) {
    return permissions.findIndex(function (currentPermission) {
      return comparePermission(currentPermission)(permissionToCheck);
    }) > -1;
  };
}; // This method checks if all given permissions are in an array of permissions


exports.checkPermission = checkPermission;

var checkPermissions = function checkPermissions(permissions) {
  return function () {
    var permissionsToCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (permissionsToCheck.length < 1) return false;
    return permissionsToCheck.reduce(function (hasPermissions, permissionToCheck) {
      return hasPermissions && checkPermission(permissions)(permissionToCheck);
    }, true);
  };
}; // This method deconstructs placeholders in permissions, so that nested selectors are possible (array|object)


exports.checkPermissions = checkPermissions;

var deconstructPlaceholder = function deconstructPlaceholder(props) {
  return function (param) {
    return param.split('.').reduce(function (prev, next) {
      return prev[next];
    }, props);
  };
}; // This method replaces the placeholders with the actual values from the same named props of the component.


exports.deconstructPlaceholder = deconstructPlaceholder;

var parsePlaceholder = function parsePlaceholder(props) {
  return function (placeholder) {
    return placeholder.replace(/\((.+?)\)/g, function (match, param) {
      return deconstructPlaceholder(props)(param);
    });
  };
}; // map granted permissions from state based on the given scope


exports.parsePlaceholder = parsePlaceholder;

var mapScopeToPermissions = function mapScopeToPermissions(scope) {
  return function (state) {
    return {
      grantedPermissions: state.permissions[scope] || []
    };
  };
}; // Protects a component from being rendered if the authorized permissions are not granted.


exports.mapScopeToPermissions = mapScopeToPermissions;

var protectComponent = function protectComponent(authorizedPermissions) {
  return function (WrappedComponent) {
    var Authorized = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
      var grantedPermissions = props.grantedPermissions,
          other = _objectWithoutProperties(props, _excluded); // This method is used to check permissions against all granted permissions.


      var hasPermissions = (0, _react.useCallback)(function (permissions) {
        return checkPermissions(grantedPermissions)(permissions);
      }, [grantedPermissions]);

      if (authorizedPermissions === null) {
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({
          hasPermissions: hasPermissions,
          ref: ref
        }, other));
      } // resolve all placeholders in  permissions to their string


      var resolvedPermissions = authorizedPermissions.map(parsePlaceholder(other)); // render wrapped component only if permissions are granted

      if (!hasPermissions(resolvedPermissions)) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({
        hasPermissions: hasPermissions,
        ref: ref
      }, other));
    }); // wrap display name for debugging


    Authorized.displayName = "Authorized(".concat(getDisplayName(WrappedComponent), ")");
    Authorized.propTypes = {
      grantedPermissions: _propTypes["default"].arrayOf(_propTypes["default"].string)
    };
    Authorized.defaultProps = {
      grantedPermissions: []
    }; // pass over all static methods and properties from original to the wrapped component

    (0, _hoistNonReactStatics["default"])(Authorized, WrappedComponent);
    return Authorized;
  };
}; // This method preloads the granted permissions for the returned authorize method from an array


var authorizeFromArray = function authorizeFromArray(grantedPermissions) {
  return function (permissions) {
    return function (WrappedComponent) {
      var PermissionProvider = function PermissionProvider(props) {
        var Authorized = protectComponent(permissions)(WrappedComponent);
        return /*#__PURE__*/_react["default"].createElement(Authorized, _extends({
          grantedPermissions: grantedPermissions
        }, props));
      };

      PermissionProvider.displayName = 'ArrayPermissionProvider';
      return PermissionProvider;
    };
  };
}; // This method preloads the granted permissions for the returned authorize method from the redux store


exports.authorizeFromArray = authorizeFromArray;

var authorizeFromRedux = function authorizeFromRedux() {
  return function (scope) {
    return function (permissions) {
      return function (Comp) {
        // mapScopeToPermissions returns the mapStateToProps function preloaded with the correct scope
        // protectComponent(permissions)(Comp) is the wrapped Component being passed to the connect function.
        var ReduxPermissionProvider = (0, _reactRedux.connect)(mapScopeToPermissions(scope), null, null, {
          forwardRef: true
        })(protectComponent(permissions)(Comp));
        ReduxPermissionProvider.displayName = 'ReduxPermissionProvider';
        return ReduxPermissionProvider;
      };
    };
  };
};

exports.authorizeFromRedux = authorizeFromRedux;

var _default = authorizeFromRedux();

exports["default"] = _default;